import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { AccessionDetailPage } from "@/features/accession/routes/AccessionDetail";

export const Route = createLazyFileRoute("/_auth/_app/accessions_/$id/")({
  component: memo(() => {
    const params = Route.useParams();
    return <AccessionDetailPage id={params.id} />;
  }),
});
